import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <IndexSection />
        <FaqSection />
        <CommentsSection />
        <AboutSection />
        <UpdatesSection />
        <RankingSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}